import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogData } from '../b2b-create-shipment.component';

@Component({
    selector: 'dialog-selectSenderInfo',
    styleUrls: ['select-sender-info-dialog.css'],
    templateUrl: 'select-sender-info-dialog.html',

})
export class SelectSenderInfoDialog implements OnInit {
    @ViewChild("senderPlacesRef") senderPlacesRef;
    forbiddenCountryCodes = [
        "DZ", "AO", "BJ", "BW", "BF", "BI", "CV", "CM", "CF", "TD", "KM", "CG", "CD", "DJ", "EG", "GQ", "ER", "SZ", "ET", "GA",
        "GM", "GH", "GN", "GW", "CI", "KE", "LS", "LR", "LY", "MG", "MW", "ML", "MR", "MU", "MA", "MZ", "NA", "NE", "NG", "RW",
        "ST", "SN", "SC", "SL", "SO", "ZA", "SS", "SD", "TZ", "TG", "TN", "UG", "ZM", "ZW", "AF", "AM", "AZ", "BH", "BD", "BT",
        "BN", "KH", "CN", "CY", "GE", "IN", "ID", "IR", "IQ", "IL", "JP", "JO", "KZ", "KW", "KG", "LA", "LB", "MY", "MV", "MN",
        "MM", "NP", "KP", "OM", "PK", "PS", "PH", "QA", "SA", "SG", "KR", "LK", "SY", "TJ", "TH", "TL", "TR", "TM", "AE", "UZ",
        "VN", "YE", "AR", "BO", "BR", "CL", "CO", "EC", "GY", "PY", "PE", "SR", "UY", "VE", "HK", "TW"
      ];

    token;
    userID;
    profileDetails;
    constructor(
        public dialogRef: MatDialogRef<SelectSenderInfoDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private toastr: ToastrService
    ) { }
    ngOnInit(): void {
        
        const filteredData = this.data.filter((item) => {
            return !this.forbiddenCountryCodes.includes(item.country_code);
        })
        this.data = filteredData;
    }

    selectAddressAndCloseDialog(index){
        const selectedAddress = this.data[index];


        let dialogCloseResponse = {
            senderName: selectedAddress.full_name,
            senderPhone: selectedAddress.phone,
            senderEmail: selectedAddress.email,
            addressLineOne: selectedAddress.line1,
            addressLineTwo: selectedAddress.line2,
            country: selectedAddress.country_code,
            cityName: selectedAddress.city_name,
            state: selectedAddress.state,
            postCode: selectedAddress.post_code,
            id: selectedAddress.id
        }


        this.dialogRef.close(dialogCloseResponse);
        

    }

    closeWithoutAddItem(): void {
        this.dialogRef.close();
    }

}